import { FocusEvent, useCallback, useRef } from 'react';

type FocusEventHandler = (event: FocusEvent<HTMLInputElement>) => void;

/**
 * Ensures that the 'onBlur' event for multiple inputs, is only called once.
 */
const useInputGroupBlurEvent = (
  onBlur: FocusEventHandler | undefined
): {
  handleBlur: FocusEventHandler;
  handleFocus: FocusEventHandler;
} => {
  const focusedInputName = useRef<string | undefined>();

  const handleFocus = useCallback(
    (event: FocusEvent<HTMLInputElement>) =>
      (focusedInputName.current = event.target.name),
    []
  );

  const handleBlur = useCallback(
    (event: FocusEvent<HTMLInputElement>) => {
      focusedInputName.current = undefined;
      setTimeout(() => {
        if (focusedInputName.current === undefined) {
          onBlur?.(event);
        }
      }, 200);
    },
    [onBlur]
  );

  return { handleBlur, handleFocus };
};

export default useInputGroupBlurEvent;
